// extracted by mini-css-extract-plugin
module.exports = {"artistPill":"MobileArtistPill_artistPill__28kph","artistCoverImage":"MobileArtistPill_artistCoverImage__28Awf"};